import React, {Component, createRef} from "react";
import FJFixedLayout from 'fj-components/FJFixedLayout'
import styles from './FJResourcesOverLayList.module.less'
import FJCustomScroll from "fj-components/FJCustomScroll";
import FJLocalStore from "../../../store/FJLocalStore";
import FJResourcesOverLayCommon from "./FJResourcesOverLayCommon";
import FJCommonPageHeader from "./FJCommonPageHeader";
import FJMediaItemPlaceholder from "./FJMediaItemPlaceholder";
import classNames from 'classnames'

class FJResourcesOverLayList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      animation: ''
    };
    this.layout = createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.isShow && (prevState.animation === 'hide' || !prevState.animation)) {

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({animation: 'show'});
    } else if (!this.props.isShow && prevState.animation === 'show') {

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({animation: 'hide'});
    }
  }

  updateUI = () => {
    let {allResources} = this.props;
    Object.keys(allResources).forEach(cate => {
      if (this[cate] && this[cate].current) {
        this[cate].current.updateUI();
      }
    });
  };

  _getCollectionList = () => {
    let {seeMore, allResources, isShow} = this.props;
    return Object.keys(allResources).map(cate => {
      return (
        <FJCommonPageHeader key={cate}
                            title={FJLocalStore._(cate)}
                            onMore={() => {seeMore(cate, cate)}}
                            render={() => {return this._renderList(cate, allResources[cate], isShow)}}
        />
      );
    });
  }
  _renderList = (cate, list, active) => {
    let {
      onAddClick,
      resourceViewInfo,
      classes,
      onMediaDrag,
      config,
      allTooltip,
      toggleTooltip,
      oneTooltip,
      hasInit,
      chooseMediaIdList
    } = this.props;

    let {
      width,
      height,
      space,
      marginBottom
    } = resourceViewInfo;

    let {
      addIcon,
      deleteIcon,
      activeColor,
      addIconToolTip
    } = config;

    if (!this[cate]) {
      this[cate] = createRef();
    }

    return <FJFixedLayout
      basicWidth={width}
      ref={this[cate]}
      space={space}
      active={active}
      className={styles.fixed_layout}
      render={(itemWidth, space, column) => {
        let itemHeight = height;
        let items = [];
        list.forEach((item, index) => {
          if ((index + 1) <= column) {
            items.push(
              hasInit ?
              <FJResourcesOverLayCommon
                key={item.name}
                id={item.name}
                width={itemWidth}
                height={itemHeight}
                marginRight={(index + 1) % column === 0 ? 0 : space}
                marginBottom={marginBottom}
                thumbnail={item.thumbnail}
                url={item.url}
                name={item.title}
                hasName={false}
                type={item.type}
                hasAddBtn
                onAddClick={onAddClick}
                classes={classes.itemClasses}
                activeColor={activeColor}
                addIcon={addIcon}
                deleteIcon={deleteIcon}
                onMediaDrag={onMediaDrag}
                addIconToolTip={addIconToolTip}
                allTooltip={allTooltip}
                toggleTooltip={toggleTooltip}
                oneTooltip={oneTooltip}
                isChoose={chooseMediaIdList.indexOf(item.name) !== -1}
              /> : <FJMediaItemPlaceholder width={138} height={88} key={item.name} />
            )
          }
        });
        return items;
      }}
    />
  }

  render() {
    let {isShow, classes, isBackShow} = this.props
    let {animation} = this.state;
    let cl = classNames(styles.list_box, {
      [styles.show]: animation === 'show' && isBackShow,
      [styles.hide]: animation === 'hide',
    });
    return (
      <div className={cl} style={{display: isShow ? 'block' : 'none'}}>
        <FJCustomScroll classes={classes.scrollClasses} render={this._getCollectionList} />
      </div>
    )
  }
}

export default FJResourcesOverLayList;
